import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { baseUrl } from '../../baseUrl'
import { Link, useParams } from 'react-router-dom'
import style from '../admin/exam/ExamResult.module.css'
import { useAuth } from '../../AuthContext'

const Result = () => {
  const {user}=useAuth()
    const params=useParams()
    const [result,setResult]=useState(null)
    const [loading,setLoading]=useState(false)
    console.log(result)
    useEffect(()=>{
      setLoading(true)
        axios.get(`${baseUrl}/student/exam/result?email=${params.email}&examId=${params.examId}`)
        .then(res=>{setResult(res.data);setLoading(false)})
        .catch(err=>{console.log(err);setLoading(false)})
    },[])
  return (
    <div className='d-flex justify-content-center'>
   {
    !loading&&result&&result.result?
    <div className='' >
           <h4 className=' mt-5'>Result</h4>
      <h5 className={` ${result.result.status==='Qualified'?'text-success':'text-danger'}`}>{result.result.status}</h5>
      <p>{result.result.message}</p>
      <p>Score : {result.score} out of {result.totalMarks}</p>
      <p>Total Questions : {(result.attemptedQuestions+result.unattemptedQuestions)}</p>
      <p>Attempted : {result.attemptedQuestions} Unattempted : {result.unattemptedQuestions}</p>

         <table className={`${style.table}`}>
                <thead>
                  <tr>
                    <th rowspan="2">Student Name</th>
                    <th colspan="3">Question Analysis<br></br><span className={`${style.qaSpan}`}>( correct | incorrect | left )</span></th>
                    <th colspan="3">Marks</th>
                    <th rowspan="2">Total<br></br><span style={{fontWeight:'400'}}>{result.totalMarks}</span></th>
                  </tr>
                  <tr>
                    <td>Phy</td>
                    <td>Chem</td>
                    <td>Bio</td>
                    <td>Phy</td>
                    <td>Chem</td>
                    <td>Bio</td>
                  </tr>
                </thead>
       
                <tbody>
                <tr>
                  <td>{result.studentName}</td>
                  <td>{result.correct.phy} | {result.inCorrect.phy} | {result.unUttempted.phy}</td>
                  <td>{result.correct.chem} | {result.inCorrect.chem} | {result.unUttempted.chem}</td>
                  <td>{result.correct.bio} | {result.inCorrect.bio} | {result.unUttempted.bio}</td>
                  <td>{result.subjectScores.physics}</td>
                  <td>{result.subjectScores.chemistry}</td>
                  <td>{result.subjectScores.biology}</td>
                  <td>{result.score}</td>
                </tr>
                </tbody>
              </table>
              <Link to={`${user?`/student/${user.email}`:'/'}`}>{user?'Back to profile':'Back to home'}</Link>
    </div>
    :
    <div>
    <h2>No result captured</h2>
    <Link to={`${user?`/student/${user.email}`:'/'}`}>{user?'Back to profile':'Back to home'}</Link>
    </div>
    
   }

    </div>
  )
}

export default Result
